export enum AssessmentSidebarTab {
  artifacts = "Items",
  workHistory = "Work history",
  askAI = "Ask AI",
  rolesAndReviews = "Role & Reviews",
  context = "Context",
}
